import clsx from "clsx"
import PropTypes from "prop-types"
import { Controller, useFormContext } from "react-hook-form"

const Checkbox = ({ label, id, className, title, ...inputProps }) => {
  const { control } = useFormContext()
  return (
    <Controller
      control={control}
      name={id}
      render={({
        field: { value, onChange, onBlur },
        fieldState: { error },
      }) => (
        <div
          className={clsx(
            "flex flex-col relative mb-4 w-full",
            className && className,
          )}
        >
          <p className="text-xs text-brand-secondary font-semibold mt-4 mb-2">
            {title}
          </p>
          <div className="flex items-center">
            <label htmlFor={id} className="text-[12px]">
              {label}
            </label>
            <input
              onChange={onChange}
              onBlur={onBlur}
              checked={value ?? false}
              id={id}
              type="checkbox"
              className="ml-2 "
              {...inputProps}
            />
            {error && (
              <p className="text-xs text-red-500 absolute -bottom-5">
                {error?.message}
              </p>
            )}
          </div>
        </div>
      )}
    />
  )
}

Checkbox.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
}

export default Checkbox
